export const styles = {
  root: {
    padding: "0px 10px",
    margin: "0px",
    backgroundColor: "events.dialogContentBackground",
  },
};
